import { FC } from 'react'
import { times } from 'lodash'
import styled from 'styled-components'
import Skeleton from '@app.components/Skeleton'
import FilterFieldWrapper from '@app.feature/activityFilter/components/FilterFieldWrapper'

const FIELD_TIMES = times(3)
const FIELD_ITEM_TIMES = times(6)

const ActivityFilterSlidesLoading: FC = () => {
  return (
    <StyledWrapper>
      {FIELD_TIMES.map((rootIndex) => (
        <FilterFieldWrapper
          key={rootIndex}
          label={<Skeleton width={60} height={20} />}
        >
          <div className="field-item-wrapper">
            {FIELD_ITEM_TIMES.map((index) => (
              <Skeleton key={index} width="100%" height={50} />
            ))}
          </div>
        </FilterFieldWrapper>
      ))}
    </StyledWrapper>
  )
}

export default ActivityFilterSlidesLoading

const StyledWrapper = styled.div`
  > div:not(:last-child) {
    margin-bottom: 50px;
  }

  .field-item-wrapper {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
`
